import { useState } from "react";
import { Button, Card, Input } from "../components/ui";

type Props = {
  onLogin: (email: string, password: string) => Promise<void>;
};

export function Login({ onLogin }: Props) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await onLogin(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Login fehlgeschlagen");
    } finally {
      setLoading(false);
    }
  }

  return (
    <main className="min-h-screen gradient-radial-warm grid place-items-center px-4 py-12">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <img
            src="/logo.png"
            alt="DP Connect"
            className="mx-auto mb-4 size-16"
          />
          <h1 className="text-2xl font-semibold tracking-tight">DP Connect Agenten</h1>
          <p className="mt-1 text-sm text-ink-muted">
            Empfehlungs-Plattform für <span className="brand-text-gradient font-medium">dpconnect.de</span>
          </p>
        </div>

        <Card className="space-y-4">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-ink-muted">
                Email
              </label>
              <Input
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="du@dpconnect.de"
              />
            </div>
            <div>
              <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-ink-muted">
                Passwort
              </label>
              <Input
                type="password"
                autoComplete="current-password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && (
              <div className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800">
                {error}
              </div>
            )}

            <Button type="submit" disabled={loading} className="w-full">
              {loading ? "Anmelden…" : "Anmelden"}
            </Button>
          </form>
        </Card>

        <p className="mt-6 text-center text-xs text-ink-muted">
          Noch kein Konto?{" "}
          <a href="/join" className="text-accent-orange hover:underline">
            Agent werden
          </a>
        </p>
      </div>
    </main>
  );
}
